import React from 'react';
import { THEME_2026 } from '../lib/theme2026';

// The one Charlie wordmark: white C.H.A.R.L.I., gold final E, grey WELL REPD ERP subline. The loading screen and the sidebar both render this, so they cannot drift apart.
export default function CharlieWordmark({
  fontSize,
  letterSpacing,
  showSubline = true,
  sublineSize,
  sublineSpacing,
  sublineMarginTop = 0,
  wordmarkTestId,
  eTestId,
  sublineTestId,
  title,
  children,
}) {
  return (
    <div>
      <div
        data-testid={wordmarkTestId}
        title={title}
        style={{ fontSize, fontWeight: 800, letterSpacing, lineHeight: 1, color: THEME_2026.wordmarkWhite }}
      >
        C.H.A.R.L.I.<span data-testid={eTestId} style={{ color: THEME_2026.warmGoldHighlight }}>E</span>.
      </div>
      {showSubline && (
        <div
          data-testid={sublineTestId}
          style={{ fontSize: sublineSize, color: THEME_2026.wordmarkGrey, letterSpacing: sublineSpacing, marginTop: sublineMarginTop, fontWeight: 600 }}
        >
          WELL REPD ERP
        </div>
      )}
      {children}
    </div>
  );
}
